import React from "react";
import { t } from "@client/lib/dictionary";
import type { TracerTelemetry } from "@client/types/tracer";
import { Card, CardContent, CardHeader, CardTitle } from "@client/components/ui/card";

interface Props {
  telemetry: TracerTelemetry | undefined;
}

/** Hard fault keys → red badge, ostatní → amber. */
const FAULT_KEYS: ReadonlySet<string> = new Set([
  "BAT_FAULT",
  "FAULT",
  "CHARGING_MOSFET_SHORT",
  "ANTI_REVERSE_MOSFET_SHORT",
  "CHARGING_OR_ANTI_REVERSE_MOSFET_SHORT",
  "LOAD_SHORT",
  "LOAD_MOSFET_SHORT",
  "PV_INPUT_SHORT",
  "BAT_LOW_DISCONNECT",
]);

export const TracerAlarmsBar: React.FC<Props> = ({ telemetry }) => {
  const active = telemetry?.activeWarnings ?? [];
  const labels = t.tracer.alarms as Record<string, string>;
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.tracer.detail.alarms}</CardTitle>
      </CardHeader>
      <CardContent>
        {active.length === 0 ? (
          <div className="text-muted-foreground text-sm">{t.tracer.detail.noAlarms}</div>
        ) : (
          <div className="flex flex-wrap gap-2">
            {active.map((key) => {
              const label = labels[key] ?? key;
              const color = FAULT_KEYS.has(key) ? "bg-red-600 text-white" : "bg-amber-500 text-white";
              return (
                <span
                  key={key}
                  className={`inline-flex items-center gap-1 text-xs font-medium rounded px-2 py-1 ${color}`}
                >
                  {label}
                </span>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
